<template>
    <div class="degree_setback">
        <div class="form-group"
             :id="fieldName + '-technology-field'"
             :class="{ 'has-error': form.errors.has(this.fieldConfig.value_field) }"
        >

            <label class="form-control-label">{{ fieldConfig.label }}<span class="required" v-if="fieldConfig.field_extra.required">&nbsp;&nbsp;(*)</span></label>
            <div class="form-group">
                <label class="form-control-label">Heating (&deg;F)</label>
                <input type="text" v-model="heating_setback" class="form-control">
            </div>
            <div class="form-group">
                <label class="form-control-label">Cooling (&deg;F)</label>
                <input type="text" v-model="cooling_setback" class="form-control">
            </div>

            <span class="help-block" v-if="form.errors.has(this.fieldConfig.value_field)">
                {{ form.errors.get(this.fieldConfig.value_field, true) }}
            </span>
        </div>
    </div>
</template>
<script>
    import { FormFieldMixin } from 'laravel-vue-forms';
    export default {

        mixins: [FormFieldMixin],

        data() {
            return {

            }
        },


        computed: {
            heating_setback: {
                get() {
                    return this.specialTextValue.heating_setback;
                },
                set(heating_setback) {
                    this.emit(heating_setback, this.cooling_setback)
                }
            },
            cooling_setback: {
                get() {
                    return this.specialTextValue.cooling_setback;
                },
                set(cooling_setback) {
                    this.emit(this.heating_setback, cooling_setback);
                }
            },
            specialTextValue() {
                if(this.value) {
                    return this.value;
                }else {
                    return {
                        heating_setback: null,
                        cooling_setback: null
                    };
                }
            }
        },

        methods: {
            emit(heating_setback, cooling_setback) {
                this.$emit('input', {
                    heating_setback,
                    cooling_setback
                });
            }
        }

    }
</script>
